const moment = require("moment");

export default {

    data(){
        return{
            // 
            api: process.env.VUE_APP_API_URL
        }
    },

    computed:{
        user() {
            return this.$store.state.user;
        },
        scalifyAccessToken() {
            return this.$store.state.scalifyAccessToken;
        },
        listConnectedAccounts(){
            return this.$store.state.listAccounts
        },
        loadingConnectedAccounts(){
            return this.$store.state.loadingAccounts
        }
    },

    methods: {

            // ------------------------------- POST & GET------------------------------- //

                // Post Data
                async postDataWithoutToken(endpoint, data){
                    try {
                        var res = await this.$axios.post(endpoint, data);

                        // console.log('Post: ', res);
                        if (res && res.data && (res.data.status == "Token is Invalid" || res.data.status == "Token is Expired")) {
                            this.$router.push('/login');
                            return;
                        }
                        return res.data;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                // Post Data
                async postData(endpoint, data){
                    this.$axios.defaults.headers.common["X-Scalify-Token"] = this.scalifyAccessToken;
                    try {
                        var res = await this.$axios.post(endpoint, data);

                        // console.log('Post: ', res);
                        if (res && res.data && (res.data.status == "Token is Invalid" || res.data.status == "Token is Expired")) {
                            this.$router.push('/login');
                            return;
                        }
                        return res.data;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

                // Get Data
                async getData(endpoint){
                    this.$axios.defaults.headers.common["X-Scalify-Token"] = this.scalifyAccessToken;
                    try {
                        var res = await this.$axios.get(endpoint);
                        if (res && res.data && (res.data.status == "Token is Invalid" || res.data.status == "Token is Expired")) {
                            this.$router.push('/login');
                            return;
                        }
                        // console.log('Get: ', res);
                        return res.data;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

            // ------------------------------- Functions ------------------------------- //
                async login(email, password){
                    try {

                        const data = {email:email, password:password};
                        var res = await this.postDataWithoutToken(this.api+"/login", data);
                        // console.log('res: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async userData(){
                    try {
                        var userInfo = await this.getData(this.api+"/api/admin/info");
                        // console.log('userInfo: ', userInfo);
                        return userInfo;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async saveMeaningfulMessage(id,faqUrl,meaningfulMessage){
                    try {
                        const data = {faq_url : faqUrl , meaningful_message : meaningfulMessage}
                        var userInfo = await this.postData(this.api+"/api/admin/errors/"+id+"/edit", data);
                        // console.log('userInfo: ', userInfo);
                        return userInfo;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async plansTable(){
                    try {
                        var plansTable = await this.getData(`${this.api}/api/admin/billing/plans`);
                        return plansTable;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async accountsTable(start,end,page,sortField,sortType,filterType){
                    try {

                        var accountsTable;
                        if (sortField && sortType) {

                            accountsTable = await this.getData(`${this.api}/api/admin/accounts?start=${start}&end=${end}&per_page=25&page=${page}&sort_field=${sortField}&sort_type=${sortType}${filterType && filterType.value ? '&type='+filterType.value : ''}`);

                        }else{

                            accountsTable = await this.getData(`${this.api}/api/admin/accounts?start=${start}&end=${end}&per_page=25&page=${page}${filterType && filterType.value ? '&type='+filterType.value : ''}`);

                        }

                        return accountsTable;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async affiliatesTable(start,end,page){
                    try {

                        var affiliatesTable = await this.getData(`${this.api}/api/admin/affiliates?start=${start}&end=${end}&per_page=25&page=${page}`);
                        // if(affiliatesTable){
                        //     for(let i=0;i<affiliatesTable.data.length;i++){
                        //         let details = await this.getData(`${this.api}/api/admin/affiliate/${affiliatesTable.data[i].id}/details`);
                        //         if(details){
                        //             affiliatesTable.data[i].details = {...details}
                        //         }
                        //     }
                        // }
                        return affiliatesTable;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async toggleAffiliate(key,id){
                    try {
                        const data = {status:key?1:0};
                        var res = await this.postData(this.api+`/api/admin/affiliate/${id}/status`, data);
                        // console.log('res: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async accountSearch(key){
                    try {
                        const data = {keyword:key};
                        var res = await this.postData(this.api+"/api/admin/accounts/search", data);
                        // console.log('res: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async affiliatesSearch(key){
                    try {
                        const data = {keyword:key};
                        var res = await this.postData(this.api+"/api/admin/affiliates/search", data);
                        // console.log('res: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async tasksTable(start,end,page){
                    try {

                        var tasksTable = await this.getData(`${this.api}/api/admin/tasks?start=${start}&end=${end}&per_page=25&page=${page}`);
                        return tasksTable;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async errorsTable(page){
                    console.log('page: ', page);
                    try {

                        var errorsTable = await this.getData(`${this.api}/api/admin/errors?per_page=25&page=${page}`);
                        return errorsTable;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async feedbacksTable(){
                    try {

                        var feedbacksTable = await this.getData(`${this.api}/api/admin/feedbacks`);
                        return feedbacksTable;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async accountDetails(endpoint){
                    try {

                        var accountDetails = await this.getData(endpoint);
                        console.log("accountDetails",accountDetails)
                        return accountDetails;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async taskDetails(endpoint){
                    try {

                        var taskDetails = await this.getData(endpoint);
                        return taskDetails;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async taskSearch(key,page){
                    try {

                        const data = {keyword:key};
                        var res = await this.postData(this.api+"/api/admin/tasks/search?per_page=25&page="+page, data);
                        // console.log('res: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async editTaskAction(endpoint, jsonObject){
                    try {

                        const data = {settings:jsonObject};
                        var res = await this.postData(endpoint, data);
                        // console.log('res: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async extendTrial(id, numberDays){
                    try {

                        const data = {days : numberDays};
                        var res = await this.postData(`${this.api}/api/admin/account/${id}/extend-trial`, data);
                        // console.log('res: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

            // ------------------------------- Plans and Coupons ------------------------------- //

                async listPlansTable(page){
                    try {
                        var plansTable = await this.getData(`${this.api}/api/admin/plans?per_page=25&page=${page}`);
                        return plansTable;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async createNewPlan(planObject){
                    try {
                        var newPlan = await this.postData(`${this.api}/api/admin/plans`, planObject);
                        return newPlan;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async editPlan(planObject, planId){
                    try {
                        var plan = await this.postData(`${this.api}/api/admin/plans/${planId}/edit`, planObject);
                        return plan;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async deletePlan(planId){
                    try {
                        var deletePlan = await this.postData(`${this.api}/api/admin/plans/${planId}/delete`);
                        return deletePlan;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async plansSearch(key, page){
                    try {
                        let data = {keyword: key}
                        var plans = await this.postData(`${this.api}/api/admin/plans/search?per_page=25&page=${page}`, data);
                        return plans;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

                async listCouponsTable(page){
                    try {
                        var couponsTable = await this.getData(`${this.api}/api/admin/coupons?per_page=25&page=${page}`);
                        return couponsTable;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async createNewCoupon(couponObject){
                    try {
                        var newPlan = await this.postData(`${this.api}/api/admin/coupons`, couponObject);
                        return newPlan;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async editCouponStatus(couponObject, couponId){
                    try {
                        var coupon = await this.postData(`${this.api}/api/admin/coupons/${couponId}/edit`, couponObject);
                        return coupon;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async deleteCoupon(coponId){
                    try {
                        var deleteCoupon = await this.postData(`${this.api}/api/admin/coupons/${coponId}/delete`);
                        return deleteCoupon;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async refundCouponCode(coponCode){
                    try {
                        var refundCoupon = await this.postData(`${this.api}/api/admin/coupons/${coponCode}/cancel`);
                        return refundCoupon;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },
                async couponsSearch(key, page){
                    try {
                        let data = {keyword: key}
                        var plans = await this.postData(`${this.api}/api/admin/coupons/search?per_page=25&page=${page}`, data);
                        return plans;
                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

            // ------------------------------- About Charts ------------------------------- //

                // Get Data Charts3

                async getCharts(metric, startDate, endDate, status,endpoint){
                    // console.log("metric: ", metric);
                    // console.log("status: ", status);
                    // console.log("startDate: ", startDate);
                    // console.log("endDate: ", endDate);
                    try {
                        var chartData;
                        if(endpoint){
                            chartData = await this.getData(`${this.api}/api/admin${endpoint}`);
                        }
                        else{
                            let start = moment(startDate).format('YYYY-MM-DD')
                            let end = moment(endDate).format('YYYY-MM-DD')
                            if (status) {
                                chartData = await this.getData(`${this.api}/api/admin/stats?start=${start}&end=${end}&type=${metric}&status=${status}`);
                            }else{
                                chartData = await this.getData(`${this.api}/api/admin/stats?start=${start}&end=${end}&type=${metric}`);
                            }
                        }
                        // console.log('chart: ', chartData);
                        return chartData;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

                async getChartsPie(metric, startDate, endDate){
                    // console.log("metric: ", metric);
                    // console.log("startDate: ", startDate);
                    // console.log("endDate: ", endDate);
                    let start = moment(startDate).format('YYYY-MM-DD')
                    let end = moment(endDate).format('YYYY-MM-DD')
                    try {

                        let chartData = await this.getData(`${this.api}/api/admin/stats/${metric}?start=${start}&end=${end}`);

                        // console.log('chart: ', chartData);
                        return chartData;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },


            // ------------------------------- About Automation------------------------------- //

                async automationTable(start,end,page,sortData){
                    try {

                        var automationTable = await this.getData(`${this.api}/api/admin/automations?start=${start}&end=${end}&per_page=25&page=${page}&sort_field=${sortData.sort_field}&sort_type=${sortData.sort_type}`);
                        console.log('automationTable: ', automationTable);
                        return automationTable;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

                async reviewTable(start,end,page){
                    try {

                        var reviewTable = await this.getData(`${this.api}/api/admin/feedbacks?start=${start}&end=${end}&per_page=25&page=${page}`);
                        console.log('reviewTable: ', reviewTable);
                        return reviewTable;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

                async automationSearch(key,page){
                    try {

                        const data = {keyword:key};
                        var res = await this.postData(this.api+"/api/admin/automations/search?per_page=25&page="+page, data);
                        console.log('resres: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

                async reviewsSearch(key,page){
                    try {

                        const data = {keyword:key};
                        var res = await this.postData(this.api+"/api/admin/feedbacks/search?per_page=25&page="+page, data);
                        console.log('resres: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

                async strategieDetails(endpoint){
                    try {

                        var strategieDetails = await this.getData(endpoint);
                        return strategieDetails;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

                async changeStatuStrategie(id,status){
                    try {

                        const data = {status  : status == true ? 1 : 0};
                        var res = await this.postData(`${this.api}/api/admin/automation/${id}/edit`, data);
                        console.log('changeStatuStrategie res: ', res);
                        return res;

                    }
                    catch(error) {
                        console.log('error: ', error);
                    }
                },

            // ------------------------------- OUR FUNCTIONS ------------------------------- //

                // show Toast
                notify(state ,text ,title,btn){
                    let button = btn?btn:null
                    let toastID = Math.random();
                    setTimeout(() => { this.removeToast(toastID) }, 7000);
                    // this.$store.state.toasts.push({id:toastID ,state: state, text: text, title:title})
                    let toasts = this.$store.state.toasts
                    let exist = false
                    for(let i=0;i<toasts.length;i++){
                        if(toasts[i].state == state && toasts[i].text == text){
                            exist = true
                            break
                        }
                    }
                    if(!exist && text && text!==""){
                        this.$store.state.toasts.push({id:toastID ,state: state, text: text, title:title,btn:button})
                    }
                    else{
                        return
                    }
                },
                removeToast(id) {
                    var index = this.$store.state.toasts.findIndex(obj => obj.id == id)
                    if (index != -1) {
                        this.$store.state.toasts.splice(index, 1)
                    }
                },
                setToken(token) {
                    this.$store.state.scalifyAccessToken = token;
                    this.$Cookies.set("X-Scalify-Token", token, { expires: 30 });
                },
                checkToken() {
                    // if we have a token
                    if (this.$Cookies.get("X-Scalify-Token")) {

                        // set cookies in axios
                        this.$store.state.scalifyAccessToken = this.$Cookies.get("X-Scalify-Token");
                        return true;

                    }
                    else {
                        // redirect to login
                        this.$router.push("/login");
                        return false;

                    }
                },
                // check an object if empty
                isEmpty(obj) {
                    for(var prop in obj) {
                        // if(obj.hasOwnProperty(prop))
                         return false;
                    }
                    return true;
                },
                capitalize(text) {
                    return text.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
                },
                dateDiffInDays(d1, d2) {
                    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                    // Discard the time and time-zone information.
                    const utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
                    const utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());

                    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
                },
                getDates(startDate, endDate,days) {
                    var dateArray = [];
                    var currentDate = moment(startDate);
                    var stopDate = moment(endDate);
                    while (currentDate <= stopDate) {
                        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
                        if(days == 30){
                            currentDate = moment(currentDate).add(1, 'month');
                        }else if (days == 7){
                            currentDate = moment(currentDate).add(1, 'week');
                        }else{
                            currentDate = moment(currentDate).add(days, 'days');
                        }
                    }
                    return dateArray;
                },
                getHours(date) {
                    var x = 60; //minutes interval
                    var times = []; // time array
                    var tt = 0; // start time
                    var ap = ['AM', 'PM']; // AM-PM

                    //loop to increment the time and push results in array
                    for (var i=0;tt<24*60; i++) {
                        var hh = Math.floor(tt/60); // getting hours of day in 0-24 format
                        var mm = (tt%60); // getting minutes of the hour in 0-55 format
                        times[i] = date+' '+("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2)+" "+ ap[Math.floor(hh/12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
                        tt = tt + x;
                    }

                    return times;
                },
                kFormatter(num) {
                    return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
                },
                fromNow(date){
                    return moment(date).fromNow()
                },
                formatDate(date) {
                    let monthNames = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct","Nov", "Dec"];
                    let day = date.getDate();
                    let monthIndex = date.getMonth();
                    let year = date.getFullYear();
                    return monthNames[monthIndex] +' '+day +', ' + year;
                },
                nl2br(str, is_xhtml) {
                    var breakTag =
                        is_xhtml || typeof is_xhtml === "undefined" ? "<br " + "/>" : "<br>"; // Adjust comment to avoid issue on phpjs.org display

                    return (str + "").replace(
                        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
                        "$1" + breakTag + "$2"
                    );
                },
                openCTA(data,id){
                    if(data.type=="WHATSAPP_MESSAGE"){
                        window.open(`https://api.whatsapp.com/send?phone=${data.value.whatsapp_number}`,'_blank')
                    }
                    else if(data.type=="MESSAGE_PAGE"){
                        window.open(`https://www.facebook.com/${id}`,'_blank')
                    }
                },
                openUrl(url){
                    window.open(`${url}`,'_blank')
                },
                formattingNumber(nb){
                    return parseFloat(nb).toLocaleString("en-US")
                },
                handleErrors(err){
                    if(window && window.location && window.location.hostname !== "localhost"){
                        // alert(this.$t('errors.an_error_occured_try_again'));
                    }
                    else{
                        this.notify("error","Error to handle")
                        console.log("the error is : ",err)
                    }
                }
    }
};